import { AxiosError } from "axios";
import taskManagerApi from "@/features/shared/services/taskManagerApi";
const mapTeamListResponse = (response) => {
    const teams = response?.data?.data?.teams ?? [];
    const meta = response?.data?.data?.meta ?? null;
    return { teams, meta };
};
export const fetchTeams = async (params = {}) => {
    const response = await taskManagerApi.get("/team", {
        params: {
            page: params.page,
            limit: params.limit,
            all: params.all,
            name: params.name,
            manager_id: params.manager_id,
        },
    });
    return mapTeamListResponse(response);
};
export const fetchTeam = async (id) => {
    const response = await taskManagerApi.get(`/team/${id}`);
    return response.data?.data?.team;
};
export const createTeam = async (payload) => {
    const response = await taskManagerApi.post("/team", payload);
    return response.data?.data?.team;
};
export const updateTeam = async (id, payload) => {
    const response = await taskManagerApi.put(`/team/${id}`, payload);
    return response.data?.data?.team;
};
export const deleteTeam = async (id) => {
    await taskManagerApi.delete(`/team/${id}`);
};
export const fetchTeamMembers = async (teamId) => {
    const response = await taskManagerApi.get(`/team/${teamId}/members`);
    return response.data?.data?.members ?? [];
};
export const addTeamMembers = async (teamId, members) => {
    const response = await taskManagerApi.post(`/team/${teamId}/members`, { members });
    return response.data?.data?.members ?? [];
};
export const removeTeamMember = async (teamId, memberId) => {
    await taskManagerApi.delete(`/team/${teamId}/members/${memberId}`);
};
export const getTeamErrorMessage = (error) => {
    if (error instanceof AxiosError) {
        const apiError = error.response?.data?.error;
        const apiMessage = apiError?.message ?? error.response?.data?.message;
        if (apiMessage) {
            return apiMessage;
        }
        if (apiError?.code === "MANAGER_PERMISSION_REQUIRED") {
            return "Le responsable sélectionné doit disposer de la permission can_lead_team.";
        }
    }
    if (error instanceof Error) {
        return error.message;
    }
    return "Une erreur inattendue est survenue.";
};
export const buildTeamPayload = (values) => ({
    name: values.name.trim(),
    color: values.color.trim(),
    icon: values.icon?.trim() ? values.icon.trim() : undefined,
    manager_id: values.manager_id ?? undefined,
    members: Array.from(new Set(values.members)),
});
